import data from "./DataAboutMe";
import "./AboutMe.scss";

export default function AboutMe() {
  let content = data.data;
  return (
    <div className="container">
      <div className="main my-5">
        <div className="content_sobre">
          {content.map((item, key) => (
            <div
              className="row justify-content-center align-items-center"
              key={key}
            >
              <div
                className={`col-12 col-md-6 ${
                  key % 2 === 0 ? "order-0 order-md-1 ps-md-0" : "pe-md-0"
                }`}
              >
                <img src={item.image} className="img-fluid" alt="" />
              </div>
              <div className="col-12 col-md-6">
                <div className="p-4">
                  {item.text.map((i, k) => (
                    <p>{i}</p>
                  ))}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
